module.exports = __webpack_public_path__ + "assets/img/qrcode-gzh.30549184.png";